var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9519 19.8355L27.9398 26.7844C27.1535 28.1645 25.6931 28.8867 24.2166 28.7904H21.007V32L16.995 24.7783L21.007 17.5567V20.7663H25.5326L21.9699 14.5878L28.9188 10.5757L31.8074 15.5827C32.6419 16.8185 32.7543 18.4714 31.9519 19.8355ZM11.7151 0H19.7392C21.3119 0 22.676 0.914744 23.334 2.23069L24.9388 5.02307L27.7151 3.41825L23.4784 10.4955L15.2136 10.6399L17.99 9.0351L15.7272 5.10331L12.1805 11.2818L5.21565 7.26981L8.10431 2.26279C8.76229 0.930792 10.1264 0 11.7151 0ZM5.03912 26.8004L1.02708 19.8516C0.240722 18.4875 0.353059 16.8505 1.17151 15.6148L2.77633 12.8385L0 11.2337L8.24875 11.3621L12.5015 18.4554L9.72517 16.8506L7.46239 20.7663H14.5878V28.7904H8.81043C7.31795 28.9027 5.84152 28.1645 5.03912 26.8004Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemiz);
export default __webpack_public_path__ + "static/media/temiz.935258e42979c73d2caa1a395d3c77e4.svg";
export { ForwardRef as ReactComponent };